import { Component, Input, OnInit } from '@angular/core';
import { CustomerService } from '../../services/customer.service';
import { ErrorService } from '../../services/error.service';
import { FileService } from '../../services/file.service';
import { SpinnerService } from '../../services/spinner.service';

@Component({
	selector: 'app-download-file-combo-button',
	templateUrl: './download-file-combo-button.component.html',
	styleUrls: ['./download-file-combo-button.component.scss']
})
export class DownloadFileComboButtonComponent implements OnInit {
	public defaultFileType: string;
	@Input() public fileType: string;
	@Input() public id: number;

	constructor(private _fileService: FileService,
				private _errorService: ErrorService,
				private _spinnerService: SpinnerService,
				private _customerService: CustomerService) {
	}

	downloadFile(id, convertTo): void {
		this._spinnerService.startSpinner();
		this._fileService.getFile(id, convertTo).subscribe(
			(response) => {
				// We get base64 but need a blob so convert it, using mime-types library to
				// guess the mime type based on file extension - This is not fool proof as file
				// extensions can be spoofed
				const blob = this._fileService.convertToBlob(response);
				// If IE or Edge
				if ((window.navigator as any).msSaveBlob) {
					this._spinnerService.stopSpinner();
					return (window.navigator as any).msSaveBlob(blob, response.fileName);
				}
				const reader = new FileReader();
				reader.onload = (e) => {
					// Fake some stuff out to download and set the file name
					const a = document.createElement('a');
					a.style.display = 'none';
					a.setAttribute('href', reader.result as string);
					a.setAttribute('download', response.fileName);
					document.body.appendChild(a);
					a.click();
					a.remove();
					this._spinnerService.stopSpinner();
				};
				reader.readAsDataURL(blob);
			},
			(error) => {
				this._spinnerService.stopSpinner();
				this._errorService.error(error, 'downloadFile Failed', 'modal');
			}
		);
	}

	ngOnInit(): void {
		const selectedCustomer = this._customerService.getSelectedCustomer();
		this.defaultFileType = selectedCustomer ? selectedCustomer.defaultImageConversion : 'NO_CONVERSION';
	}

}
